import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.unregister({
  onSuccess: () => console.log('✅ PWA 설치 준비 완료!'),
  onUpdate: () => console.log('🔄 새 버전 사용 가능!'),
});

reportWebVitals();